import { api } from "shared/redux/api"
import { objectToQueryString } from "shared/utils/common"

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getClassSituationLXO: build.query({
      query: (params) => {
        return {
          url: `/private/lxo/v1/class-situation?${objectToQueryString(params)}`,
        }
      },
    }),
    getClassSituationLXOCount: build.query({
      query: (params) => {
        const searchParams = new URLSearchParams(params)

        return {
          url: `/private/lxo/v1/class-situation/count?${objectToQueryString(
            params
          )}`,
        }
      },
    }),
    getClassSituationLXONumberBlock: build.query({
      query: (params) => ({
        url: `/private/lxo/v1/class-situation/number-block`,
        params,
      }),
    }),
    createClassSituationNoteLXO: build.mutation({
      query: (body) => {
        return {
          url: "/private/lxo/v1/class-situation/note",
          method: "POST",
          body,
        }
      },
    }),
  }),
  overrideExisting: false,
})

export const {
  useLazyGetClassSituationLXOQuery,
  useLazyGetClassSituationLXOCountQuery,
  useLazyGetClassSituationLXONumberBlockQuery,
  useCreateClassSituationNoteLXOMutation,
} = injectedRtkApi
